// extracted by mini-css-extract-plugin
module.exports = {"PeaceOfMind":"PeaceOfMind_PeaceOfMind__dZRos"};